import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const fetchSchoolclassGroup = createAsyncThunk(
    '/api/schoolclassGroup/schoolclassGroupId',
    (schoolclassGroupId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup/${schoolclassGroupId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchSchoolclassGroups = createAsyncThunk(
    '/api/schoolclassGroup/get',
    (args, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postSchoolclassGroup = createAsyncThunk(
    '/api/schoolclassGroup/post',
    (newSchoolclassGroup, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup`, method: 'POST', body: newSchoolclassGroup }, rejectWithValue)
);

export const putSchoolclassGroup = createAsyncThunk(
    '/api/schoolclassGroup/put',
    (updatedSchoolclassGroup, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup`, method: 'PUT', body: updatedSchoolclassGroup }, rejectWithValue)
);

export const deleteSchoolclassGroup = createAsyncThunk(
    '/api/schoolclassGroup/delete',
    (schoolclassGroupId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup/${schoolclassGroupId}`, method: 'DELETE' }, rejectWithValue)
);

export const fetchSchoolclassesToLink = createAsyncThunk(
    '/api/schoolclassGroup/links/schoolclassGroupId',
    (schoolclassGroupId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup/links/${schoolclassGroupId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postSchoolclassesToLink = createAsyncThunk(
    '/api/schoolclassGroup/links/post',
    (schoolclassLink, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup/links`, method: 'POST', body: schoolclassLink }, rejectWithValue)
);

export const deleteSchoolclassesToUnlink = createAsyncThunk(
    '/api/schoolclassGroup/links/delete',
    (schoolclassLink, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/schoolclassGroup/links`, method: 'DELETE', body: schoolclassLink }, rejectWithValue)
);

export const schoolclassGroupSlice = createSlice({
    name: 'schoolclassGroup',
    initialState: {
        schoolclassGroup: { data: null, status: null },
        schoolclassGroups: { data: null, status: null },
        schoolclassGroupsPost: { data: null, status: null },
        schoolclassGroupsPut: { data: null, status: null },
        schoolclassGroupsDelete: { data: null, status: null },
        schoolclassToLink: { data: null, status: null },
        schoolclassGroupsLinksPost: { data: null, status: null },
        schoolclassGroupsLinksDelete: { data: null, status: null },
    },
    reducers: {
        resetSchoolclassGroupStatus: (state) => {
            ResetSliceState(state, [
                'schoolclassGroupsPost',
                'schoolclassGroupsPut',
                'schoolclassGroupsDelete',
                'schoolclassGroupsLinksPost',
                'schoolclassGroupsLinksDelete',
            ]);
        },
        setSelectedSchoolclassGroup: (state, action) => {
            state.schoolclassGroup.data = action.payload.data;
            state.schoolclassGroup.status = action.payload.status;
        }
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchSchoolclassGroup, 'schoolclassGroup');
        CreateAsyncStatusHandler(builder, fetchSchoolclassGroups, 'schoolclassGroups');
        CreateAsyncStatusHandler(builder, postSchoolclassGroup, 'schoolclassGroupsPost');
        CreateAsyncStatusHandler(builder, putSchoolclassGroup, 'schoolclassGroupsPut');
        CreateAsyncStatusHandler(builder, deleteSchoolclassGroup, 'schoolclassGroupsDelete');
        CreateAsyncStatusHandler(builder, fetchSchoolclassesToLink, 'schoolclassToLink');
        CreateAsyncStatusHandler(builder, postSchoolclassesToLink, 'schoolclassGroupsLinksPost');
        CreateAsyncStatusHandler(builder, deleteSchoolclassesToUnlink, 'schoolclassGroupsLinksDelete');
    }
});

export const {
    resetSchoolclassGroupStatus,
    setSelectedSchoolclassGroup
} = schoolclassGroupSlice.actions;

export default schoolclassGroupSlice.reducer;